import preparedReducer from './reducer';

import {
  requestBranches,
  requestBranch,
  requestBranchOptions,
  createBranch,
  updateBranch,
  updateBranchStatus,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'branches';

export const selectors = (state) => state[SLICE_NAME];

export const selectBranchByID = (id) => (state) => state[SLICE_NAME].info[id] || {};

export const actions = {
  requestBranches,
  requestBranch,
  requestBranchOptions,
  createBranch,
  updateBranch,
  updateBranchStatus,
};
